import { TicketCategory, TicketSubCategory } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

import { useDataFetchIndicator } from '..';

const { api } = vopayApi;

export default function useFetchTicketCategoryTypes() {
  const source = axios.CancelToken.source();
  const [fetching, setFetching] = useState(false);
  const [ticketCategories, setTicketCategories] = useState<TicketCategory[]>([]);
  const [ticketSubCategories, setTicketSubCategories] = useState<TicketSubCategory[]>([]);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function fetchTicketCategoryTypes() {
    try {
      setFetching(true);
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchTicketCategories(source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setTicketCategories(res.SupportTicketCategory);
      setTicketSubCategories(res.SupportTicketSubCategory);

      return res;
    } finally {
      setFetching(false);
      setDataFetchingInfo(false);
    }
  }

  return {
    fetching,
    ticketCategories,
    ticketSubCategories,
    fetchTicketCategoryTypes,
  };
}
